// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@layer vierkant {
  .v-validate-pristine--style, v-dropdown.v-validate-pristine:has(> .v-component-container > p-select.ng-invalid) .p-select,
  v-dropdown > .v-component-container > p-select.ng-dirty.ng-invalid > .p-select, .v-formControl.v-validate-pristine .ng-invalid.v-component-container, .v-formControl.v-validate-pristine .ng-invalid.p-component,
  .v-formControl .ng-invalid.ng-dirty.v-component-container,
  .v-formControl .ng-invalid.ng-dirty.p-component {
    --dropdown-border: 1px solid var(--gc-color-danger);
    border-color: var(--gc-color-danger) !important;
    outline: solid 1px var(--gc-color-danger);
    outline-offset: -4px;
  }
  .v-required .v-component-label:after,
  .v-formControl.v-required .v-component-label:after {
    content: "*";
    margin-left: 0.25rem;
    color: var(--gc-color-danger);
  }
  .v-readonly, .v-readonly input {
    -webkit-user-select: none;
            user-select: none;
    pointer-events: none;
  }
}
@layer vierkant {
  v-dropdown {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--dropdown-gap-text);
  }
  v-dropdown.focus > .v-component-container > .p-inputwrapper,
  v-dropdown > .v-component-container > .p-inputwrapper-focus {
    border-radius: var(--dropdown-border-radius);
    box-shadow: var(--dropdown-box-shadow);
  }
  v-dropdown .p-select:not(.p-disabled):hover {
    border-color: var(--dropdown-border-color);
  }
  v-dropdown p-select {
    background: var(--dropdown-background) !important;
    border: var(--dropdown-border) !important;
    border-radius: var(--dropdown-border-radius) !important;
  }
  v-dropdown > .v-component-container.full {
    width: 100%;
  }
  v-dropdown > .v-component-container .p-select {
    min-height: 46px;
  }
  v-dropdown > .v-component-container .size-small {
    width: var(--dropdown-width-small) !important;
  }
  v-dropdown > .v-component-container .size-medium {
    width: var(--dropdown-width-medium) !important;
  }
  v-dropdown > .v-component-container .size-large {
    width: var(--dropdown-width-large) !important;
  }
  v-dropdown > .v-component-container .size-full {
    width: var(--dropdown-width-full) !important;
  }
  v-dropdown.v-readonly .p-dropdown-trigger {
    opacity: 0;
  }
  .p-select-overlay p-selectitem li:has(span.v-disabled) {
    cursor: none;
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
    opacity: 0.5;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/wrappers/lib/validation.sass","webpack://./src/app/modules/wrappers/lib/dropdown/dropdown.component.sass"],"names":[],"mappings":"AAAA;EACI;;;;IACI,mDAAA;IACA,+CAAA;IACA,yCAAA;IACA,oBAAA;ECIN;EDFE;;IAEI,YAAA;IACA,oBAAA;IACA,6BAAA;ECIN;EDEE;IACI,yBAAA;YAAA,iBAAA;IACA,oBAAA;ECAN;AACF;AAnBA;EACI;IACI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,6BAAA;EAqBN;EApBM;;IAEI,4CAAA;IACA,sCAAA;EAsBV;EArBM;IACI,0CAAA;EAuBV;EAjBM;IACI,iDAAA;IACA,yCAAA;IACA,uDAAA;EAmBV;EAhBU;IACI,WAAA;EAkBd;EAjBU;IACI,gBAAA;EAmBd;EAjBc;IACI,6CAAA;EAmBlB;EAlBc;IACI,8CAAA;EAoBlB;EAnBc;IACI,6CAAA;EAqBlB;EApBc;IACI,4CAAA;EAsBlB;EApBU;IACI,UAAA;EAsBd;EAlBM;IACI,YAAA;IACA,oBAAA;IACA,yBAAA;YAAA,iBAAA;IACA,YAAA;EAoBV;AACF","sourcesContent":["@layer vierkant\n    .v-validate-pristine--style\n        --dropdown-border: 1px solid var(--gc-color-danger)\n        border-color: var(--gc-color-danger) !important\n        outline: solid 1px var(--gc-color-danger)\n        outline-offset: -4px\n\n    .v-required .v-component-label:after,\n    .v-formControl.v-required .v-component-label:after\n        content: '*'\n        margin-left: 0.25rem\n        color: var(--gc-color-danger)\n    .v-formControl.v-validate-pristine .ng-invalid, \n    .v-formControl .ng-invalid.ng-dirty\n        &.v-component-container, &.p-component\n            @extend .v-validate-pristine--style    \n\n    .v-readonly, .v-readonly input\n        user-select: none\n        pointer-events: none","@use '../validation.sass'\n@layer vierkant\n    v-dropdown\n        display: flex\n        flex-direction: column\n        align-items: flex-start\n        gap: var(--dropdown-gap-text)\n        &.focus > .v-component-container > .p-inputwrapper,\n        > .v-component-container > .p-inputwrapper-focus\n            border-radius: var(--dropdown-border-radius)\n            box-shadow: var(--dropdown-box-shadow)\n        .p-select:not(.p-disabled):hover\n            border-color: var(--dropdown-border-color)\n        \n        &.v-validate-pristine:has(> .v-component-container > p-select.ng-invalid) .p-select, \n        > .v-component-container > p-select.ng-dirty.ng-invalid > .p-select\n            @extend .v-validate-pristine--style    \n        \n        p-select\n            background: var(--dropdown-background) !important\n            border: var(--dropdown-border) !important\n            border-radius: var(--dropdown-border-radius) !important\n\n        > .v-component-container\n            &.full\n                width: 100%\n            .p-select\n                min-height: 46px\n            .size-\n                &small\n                    width: var(--dropdown-width-small) !important\n                &medium\n                    width: var(--dropdown-width-medium) !important\n                &large\n                    width: var(--dropdown-width-large) !important\n                &full\n                    width: var(--dropdown-width-full) !important\n        &.v-readonly\n            .p-dropdown-trigger\n                opacity: 0\n\n    // attached to body\n    .p-select-overlay p-selectitem\n        li:has(span.v-disabled)\n            cursor: none\n            pointer-events: none\n            user-select: none\n            opacity: 0.5"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
